<template>
  <div class="grid-view">
    <div class="main-content">
      <div style="width: 100%;" class="section">
        <div style="padding-top: 5px;">
          <el-button type="primary" @click="searchClickHandler">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
          <el-button type="primary" @click="purchaseClickHandler()">{{ $t('CargoMsg.Cargo_PurchaseRegistration') }}</el-button>
          <el-button type="primary" @click="delClickHandler()">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          <el-checkbox v-model="filter.chkInvoice" style="margin-left: 10px;">{{ $t('CargoMsg.Cargo_ShowInvoiceDetails') }}</el-checkbox>
        </div>

        <el-form label-width="60px" label-position="left" :inline="true" style="padding-top: 10px;">
          <el-form-item :label="$t('CargoMsg.Cargo_InvoiceType')">
            <el-select v-model="filter.invoiceType" style="width:150px;">
              <el-option
                v-for="(item,index) in InvoiceConstant.INVOICE_TYPES_HAS_ALL"
                :key="index"
                :label="language?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TimeOfPurchase')">
            <el-date-picker v-model="filter.beginDate" :picker-options="pickerOptionsForBeginDate" style="width:130px;" type="date" value-format="yyyy-MM-dd" @change="changeBeginDate" />&nbsp;{{ $t('CargoMsg.Cargo_To') }}
            <el-date-picker v-model="filter.endDate" :picker-options="pickerOptionsForEndDate" style="width:130px;" type="date" value-format="yyyy-MM-dd" @change="changeEndDate" />
          </el-form-item>
        </el-form>
      </div>

      <cargo-up-down-resize
        class="section"
        :up-style="{display: 'flex', flexDirection: 'column', paddingBottom: '5px'}"
        :down-style="{display: 'flex', flexDirection: 'column', paddingTop: '5px'}"
        style="height: 100%"
      >
        <template
          slot="up"
        >
          <div class="section grid-wrapper" style="min-height:350px">
            <cargo-ag-grid
              key="1906062"
              config-module="1906062"
              :grid-params.sync="gridParams"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              style="flex: 1"
              @gridReady="onGridReady"
            />
          </div>
        </template>
        <template
          slot="down"
        >
          <div class="section grid-wrapper" style="min-height:350px">
            <cargo-ag-grid
              v-if="this.filter.chkInvoice"
              key="1906063"
              config-module="1906063"
              :grid-params.sync="detail.gridParams"
              :grid-options="detail.gridOptions"
              :column-defs="detail.columnDefs"
              :row-data="detail.rowData"
              style="flex: 1"
              @gridReady="onDetailGridReady"
            />
          </div>
        </template>
      </cargo-up-down-resize>
    </div>

    <!-- 购买登记 弹窗 -->
    <el-dialog
      v-if="purchaseWindow.visible"
      v-el-drag-dialog
      :visible.sync="purchaseWindow.visible"
      :title="$t('CargoMsg.Cargo_PurchaseRegistration')"
      width="350px"
      append-to-body
      :close-on-click-modal="false"
      @close="closePrchaseWindow"
    >
      <div class="app-main-inner-row" style="justify-content: center;">
        <el-form label-width="100px" label-position="right">
          <el-form-item :label="$t('CargoMsg.Cargo_InvoiceType')">
            <el-select v-model="purchaseWindow.form.invoiceType" style="width: 100%;">
              <el-option
                v-for="(item,index) in InvoiceConstant.INVOICE_TYPES"
                :key="index"
                :label="language?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_1StInvoiceNo')">
            <el-input ref="txtStartInvoiceNo" v-model="purchaseWindow.form.txtStartInvoiceNo" oninput="value=value.replace(/[^A-Za-z0-9]/g,'')" @blur="invoiceNoFocusOutHandler" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_NumberOfCopies')">
            <el-input ref="txtQuantity" v-model="purchaseWindow.form.txtQuantity" oninput="value=value.replace(/[^0-9]/g,'')" @blur="invoiceNoFocusOutHandler" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_LastInvoiceNo')">
            <el-input v-model="purchaseWindow.form.txtEndInvoiceNo" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_PurchasedBy')">
            <cargo-user-select
              ref="userAuto"
              :default-value="purchaseWindow.form.userAuto||''"
              @change="p=>{purchaseWindow.form.userAuto = p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TimeOfPurchase')">
            <el-date-picker ref="purchasingDate" v-model="purchaseWindow.form.purchasingDate" type="date" value-format="yyyy-MM-dd" style="width: 100%;" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button :disabled="purchaseWindow.saving" type="primary" @click="okEvent">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button @click="closePrchaseWindow">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import cargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { InvoiceNo } from '@/class/model/act/InvoiceNo'
import { PurchaseInvoiceRecords } from '@/class/model/act/PurchaseInvoiceRecords'
import { queryPurchaseInvoiceRecords, saveInvoiceRecords, delPurchase } from '@/api/clearing/invoiceNo'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { recordSelectedStatus } from '@/utils/agGrid'
import { isNumber2 } from '@/utils/validate'

export default {
  name: 'PurchaseRecords',
  components: { cargoUpDownResize, cargoUserSelect },
  data() {
    return {
      pickerOptionsForBeginDate: { // 设置可选时间范围
        disabledDate: this.disabledBeginDate
      },
      pickerOptionsForEndDate: { // 设置可选时间范围
        disabledDate: this.disabledEndDate
      },
      URL,
      InvoiceConstant,
      selectedItem: null,
      selectTypeNames: TYPE_NAMES,
      filter: {
        invoiceType: null,
        beginDate: '',
        endDate: '',
        chkInvoice: true // 显示发票明细
      },
      filterJson: {},
      rowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: false,
        suppressRowSelection: false,
        context: {
          componentParent: this
        },
        onRowClicked: event => { this.changeInvoiceRecords(event.data) }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Select'), checkboxSelection: true, width: 70,
          sortable: false, suppressMenu: true, suppressSizeToFit: true,
          resizable: false, headerCheckboxSelection: false
        },
        { headerName: this.$t('CargoMsg.Cargo_InvoiceType'), field: 'invoiceType', colId: 'invoiceType', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.invoiceTypeFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_StartNo'), field: 'startInvoiceNo', colId: 'startInvoiceNo', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_ClosureNo'), field: 'endInvoiceNo', colId: 'endInvoiceNo', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_NumberOfCopies'), field: 'quantity', colId: 'quantity', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_PurchasedBy'), field: 'purchaser', colId: 'purchaser', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          } },
        { headerName: this.$t('CargoMsg.Cargo_TimeOfPurchase'), field: 'purchasingDate', colId: 'purchasingDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } }],
      detail: {
        rowData: [],
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        gridParams: {},
        gridApi: null,
        columnDefs: [
          { headerName: this.$t('CargoMsg.Cargo_InvoiceType'), field: 'invoiceType', colId: 'invoiceType', width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.invoiceTypeFunc(params.value)
            } },
          { headerName: this.$t('CargoMsg.Cargo_InvoiceNo'), field: 'invoiceNo', colId: 'invoiceNo', width: 200 },
          { headerName: this.$t('CargoMsg.Cargo_VoidedBy'), field: 'abandoner', colId: 'abandoner', width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            } },
          { headerName: this.$t('CargoMsg.Cargo_VoidTime'), field: 'abandoningDate', colId: 'abandoningDate', width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            } },
          { headerName: this.$t('CargoMsg.Cargo_InvoiceStatus'), field: 'invoiceState', colId: 'invoiceState', width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.getInvoiceState(params.value)
            } },
          /* RecipientsInvoiceRecords 子表数据*/
          { headerName: this.$t('CargoMsg.Cargo_Acquirer'), field: 'recipienter', colId: 'recipienter', width: 200,
            valueFormatter: (params) => {
              const recipientsInvoiceRecords = params.data.recipientsInvoiceRecords || {}
              const value = recipientsInvoiceRecords.recipienter || 0
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', value, 'chineseName')
            } },
          { headerName: this.$t('CargoMsg.Cargo_AcquisitionTime'), field: 'recipientingDate', colId: 'recipientingDate', width: 200,
            valueFormatter: (params) => {
              const recipientsInvoiceRecords = params.data.recipientsInvoiceRecords || {}
              const value = recipientsInvoiceRecords.recipientingDate || ''
              return ColumnUtils.dateLabelFunc(value)
            } },

          { headerName: this.$t('CargoMsg.Cargo_User'), field: 'user', colId: 'user', width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            } },
          { headerName: this.$t('CargoMsg.Cargo_TimeOfUse'), field: 'usingDate', colId: 'usingDate', width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            } }
        ]
      },
      purchaseWindow: { // 购买登记弹框
        visible: false,
        form: {
          invoiceType: 0,
          txtStartInvoiceNo: '',
          txtQuantity: '',
          txtEndInvoiceNo: '',
          userAuto: '',
          purchasingDate: ''
        },
        purchases: [], // 登记记录
        saving: false // 是否正大保存
      }
    }
  },
  computed: {
    language() {
      return this.$store.getters.language === 'zh'
    }
  },
  created() {
  },
  methods: {
    // 查询
    searchClickHandler() {
      const proxy = {}
      if (this.filter.invoiceType != null) {
        proxy['invoiceType'] = this.filter.invoiceType
      }
      if (this.filter.beginDate) {
        proxy['purchasingDateMin'] = this.filter.beginDate
      }
      if (this.filter.endDate) {
        proxy['purchasingDateMax'] = this.filter.endDate
      }
      proxy['branchId'] = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      console.log('proxy===========', proxy)
      const selectedStatus = recordSelectedStatus(this.gridApi, 'uuid')
      queryPurchaseInvoiceRecords({ conMap: proxy }).then(res => {
        this.rowData = res.data
        this.detail.rowData = []
        this.gridApi.clearFocusedCell()
        selectedStatus.revert()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 购买登记
    purchaseClickHandler() {
      this.purchaseWindow.form.invoiceType = 0
      this.purchases = []
      this.saving = false // 是否正大保存
      queryPurchaseInvoiceRecords({ conMap: { temp: 'temp' }}).then(res => {
        this.purchaseWindow.purchases = res.data || []
      }).finally(() => {
        this.purchaseWindow.visible = true
      })
    },
    // 购买登记 确认
    okEvent() {
      if (this.checkModel()) {
        const invoiceRecords = new PurchaseInvoiceRecords().fillDefaultValue().getData()
        invoiceRecords.invoiceType = this.purchaseWindow.form.invoiceType
        invoiceRecords.startInvoiceNo = this.purchaseWindow.form.txtStartInvoiceNo
        invoiceRecords.endInvoiceNo = this.purchaseWindow.form.txtEndInvoiceNo
        invoiceRecords.quantity = parseInt(this.purchaseWindow.form.txtQuantity)
        invoiceRecords.purchaser = this.purchaseWindow.form.userAuto
        invoiceRecords.purchasingDate = this.purchaseWindow.form.purchasingDate
        invoiceRecords.branchId = this.$store.getters.currentOfficeId
        invoiceRecords.invoiceNo = []
        if (this.createInvoiceNo(invoiceRecords)) {
          this.saving = true
          this.loading = getLoading()
          saveInvoiceRecords(invoiceRecords).then(res => {
            this.purchaseWindow.saving = false
            if (res.data) {
              this.$message.success(this.$t('CargoMsg.Cargo_PurchaseRegisteredSuccessfully'))
              this.searchClickHandler()
              this.closePrchaseWindow()
            } else {
              this.$message.error(this.$t('CargoMsg.Cargo_OperatedFailed'))
            }
          }).finally(() => {
            this.loading.close()
          })
        }
      }
    },
    // 关闭登记弹框
    closePrchaseWindow() {
      if (this.purchaseWindow.form) {
        for (const key in this.purchaseWindow.form) {
          if (key === 'invoiceType') {
            this.purchaseWindow.form[key] = 0
            continue
          }
          this.purchaseWindow.form[key] = ''
        }
      }
      this.purchaseWindow.purchases = []
      this.purchaseWindow.visible = false
    },
    // 生成发票
    createInvoiceNo(invoiceRecords) {
      // 开始号
      const startInvoiceNo = this.purchaseWindow.form.txtStartInvoiceNo
      const endInvoiceNo = this.purchaseWindow.form.txtEndInvoiceNo
      if (isNumber2(startInvoiceNo) && startInvoiceNo.length >= 16 && endInvoiceNo && endInvoiceNo.length >= 16) { // 电子发票号位数大于16位数，先截取，然后在进行加减
        let current = startInvoiceNo
        const end = endInvoiceNo
        const numbers = []
        if (current <= end) {
          while (current <= end) {
            numbers.push(current)
            // 手动加1
            const result = []
            let carry = 1
            const numArray = current.split('').reverse()
            for (let i = 0; i < numArray.length || carry > 0; i++) {
              const currentDigit = i < numArray.length ? parseInt(numArray[i]) : 0
              const sum = currentDigit + carry
              result.push(sum % 10)
              carry = Math.floor(sum / 10)
            }
            current = result.reverse().join('')
          }
        }
        if (numbers && numbers.length > 0) {
          for (const item of numbers) {
            const invoiceNo = new InvoiceNo().fillDefaultValue().getData()
            invoiceNo.invoiceNo = item
            // 校验发票号是否存在
            if (!this.invoiceNoExtis(invoiceNo.invoiceNo)) {
              this.$message.warning(this.$t('CargoMsg.Cargo_InvoiceNoExistedRewrite', [invoiceNo.invoiceNo]))
              return false
            }
            invoiceNo.invoiceType = invoiceRecords.invoiceType
            invoiceNo.invoiceState = 0
            invoiceNo.abandoner = 0
            invoiceNo.user = 0
            invoiceNo.branchId = this.$store.getters.currentOfficeId
            invoiceRecords.invoiceNo.push(invoiceNo)
          }
        }
      } else {
        const startInvoiceLength = startInvoiceNo.length
        const strValue = startInvoiceNo.substring(0, this.getNumberIndex(startInvoiceNo))
        const startinvoice = startInvoiceNo.substring(this.getNumberIndex(startInvoiceNo), startInvoiceLength)
        const startinvoiceValue = Number(startinvoice)
        const quantity = Number(this.purchaseWindow.form.txtQuantity)
        const endInvoiceValue = startinvoiceValue + (quantity - 1)
        for (let i = startinvoiceValue; i <= endInvoiceValue; i++) {
          const invoice = new InvoiceNo().fillDefaultValue().getData()
          const subLength = String(startinvoice).length - String(i).length
          invoice.invoiceType = invoiceRecords.invoiceType
          if (subLength > 0) {
            invoice.invoiceNo = strValue + this.getFullAmmeterUID(String(i), subLength)
          } else {
            invoice.invoiceNo = strValue + i
          }
          if (!this.invoiceNoExtis(invoice.invoiceNo)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_InvoiceNoExistedRewrite', [invoice.invoiceNo]))
            return false
          }
          invoice.invoiceState = 0
          invoice.abandoner = 0
          invoice.user = 0
          invoice.branchId = this.$store.getters.currentOfficeId
          invoiceRecords.invoiceNo.push(invoice)
        }
      }
      return true
    },
    invoiceNoExtis(invoiceNo) {
      const purchases = this.purchaseWindow.purchases
      if (!purchases || purchases.length <= 0) return true
      for (const p of purchases) {
        const invoices = p.invoiceNo // 这是一个数组
        if (!invoices || invoices.length <= 0) continue
        for (const ivc of invoices) {
          if (ivc.invoiceNo === invoiceNo) {
            return false
          }
        }
      }
      return true
    },
    // 自动补位
    getFullAmmeterUID(s, u0) {
      for (let u1 = 0; u1 < u0; u1++) {
        s = '0' + s
      }
      return s
    },
    // 是否是数字
    getNumberIndex(value) {
      for (let i = 0; i < value.length; i++) {
        if (!isNaN(Number(value.charAt(i)))) {
          return i
        }
      }
      return 2
    },
    // 购买登记 验证必填项
    checkModel() {
      if (!this.purchaseWindow.form.txtStartInvoiceNo) {
        this.$message.warning(this.$t('CargoMsg.Cargo_The1StInvoiceNoCanTBeEmpty'))
        this.$refs['txtStartInvoiceNo'].focus()
        return false
      }
      if (this.purchaseWindow.form.txtStartInvoiceNo.length < 3) {
        this.$message.warning(this.$t('CargoMsg.Cargo_LOTFINMBGT3D'))
        this.$refs['txtStartInvoiceNo'].focus()
        return false
      }
      if (!this.purchaseWindow.form.txtQuantity || parseInt(this.purchaseWindow.form.txtQuantity) === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NumberOfCopiesCanTBe0'))
        this.$refs['txtQuantity'].focus()
        return false
      }
      if (!this.purchaseWindow.form.userAuto || parseInt(this.purchaseWindow.form.userAuto) === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectThePurchaser'))
        this.$nextTick(() => {
          this.$refs['userAuto'].$refs.cargoUserSelect.$refs.advanceSelectRef.focus()
        })
        return false
      }
      if (!this.purchaseWindow.form.purchasingDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_TimeOfPurchaseCanTBeEmpty'))
        this.$refs['purchasingDate'].focus()
        return false
      }
      return true
    },
    // 删除
    delClickHandler() {
      const selectedItems = this.gridApi.getSelectedRows()
      if (!selectedItems || selectedItems.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectPurchaseRecord'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToDelete'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        const keys = Array.from(selectedItems, p => p.uuid)
        this.loading = getLoading()
        delPurchase({ keys: keys }).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.searchClickHandler()
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    // 自动计算份数
    invoiceNoFocusOutHandler() {
      if (!this.purchaseWindow.form.txtQuantity || this.purchaseWindow.form.txtQuantity === '0' || !this.purchaseWindow.form.txtStartInvoiceNo || this.purchaseWindow.form.txtStartInvoiceNo.length < 3) return
      const invoiceNo = this.purchaseWindow.form.txtStartInvoiceNo
      if (isNumber2(invoiceNo) && invoiceNo.length >= 16) { // 电子发票号位数大于等于16位数，先截取，然后在进行加减
        const result = []
        let carry = Number(this.purchaseWindow.form.txtQuantity) - 1
        // 反转数组方便从个位开始计算
        const numArray = invoiceNo.split('').reverse()
        for (let i = 0; i < numArray.length || carry > 0; i++) {
          const currentDigit = i < numArray.length ? parseInt(numArray[i]) : 0
          const sum = currentDigit + carry
          result.push(sum % 10)
          carry = Math.floor(sum / 10)
        }
        // 反转结果数组得到正确顺序的字符串
        this.purchaseWindow.form.txtEndInvoiceNo = result.reverse().join('')
      } else {
        const subValue = invoiceNo.substring(0, this.getNumberIndex(invoiceNo))
        const invoiceNumber = invoiceNo.substring(this.getNumberIndex(invoiceNo), invoiceNo.length)
        const endInvoice = Number(invoiceNumber) + (Number(this.purchaseWindow.form.txtQuantity) - 1)
        if (isNaN(endInvoice)) {
          this.purchaseWindow.form.txtEndInvoiceNo = ''
          return
        }
        const subLength = String(invoiceNumber).length - String(endInvoice).length
        this.purchaseWindow.form.txtEndInvoiceNo = subValue + this.getFullAmmeterUID(String(endInvoice), subLength)
      }
    },
    // 切换发票带出发票明细
    changeInvoiceRecords(data) {
      if (!data || !data.uuid) return
      this.selectedItem = data
      if (this.selectedItem) {
        this.detail.rowData = this.selectedItem.invoiceNo || []
      }
    },
    // 各列表 API 初始化
    onGridReady(params) {
      this.gridApi = params.api
    },
    onDetailGridReady(params) {
      this.detail.gridApi = params.api
    },
    changeBeginDate() {
      if (!this.filter.beginDate) this.filter.endDate = ''
      if (this.filter.beginDate && !this.filter.endDate) this.filter.endDate = new Date()
    },
    changeEndDate() {
      if (!this.filter.endDate) this.filter.beginDate = ''
      if (this.filter.endDate && !this.filter.beginDate) {
        const curDate = new Date()
        this.filter.beginDate = new Date(curDate)
        this.filter.beginDate.setDate(curDate.getDate() - 7)
      }
    },
    // 设置不可选日期范围
    disabledBeginDate(time) {
      if (!this.filter.endDate) {
        // 设置可选择的日期为今天之后的6天内
        const curDate = (new Date()).getTime()
        return time.getTime() > curDate
      }
      const endDate = (new Date(this.filter.endDate)).getTime()
      return time.getTime() > endDate
    },
    // 设置不可选日期范围
    disabledEndDate(time) {
      if (this.filter.beginDate) {
        const endDate = (new Date(this.filter.beginDate)).getTime()
        const dateRegion = endDate - 1 * 24 * 3600 * 1000
        return time.getTime() < dateRegion
      }
    }
  }
}
</script>

